import _ from 'lodash';

const identifyCartChanges = (newCart, products, combos) => {
  let unavailableProducts = [];
  if (newCart && newCart.length > 0) {
    const keep_products = newCart.map((product) =>
      product.config_products.map((prod) => parseInt(prod.product_id))
    )[0];

    const keep_combos = newCart.map((product) => parseInt(product.combo_id));

    const keepItems = [...keep_products, ...keep_combos];

    const unavailableItems = products
      .filter(
        (product) =>
          !keepItems.includes(parseInt(product.flatProduct.product_id))
      )
      .map((prod) => ({
        product_id: prod.flatProduct.product_id,
      }));

    const unavailableCombos = combos
      .filter((combo) => !keepItems.includes(parseInt(combo?.id)))
      .map((prod) => ({ product_id: prod.id }));

    unavailableProducts = [...unavailableItems, ...unavailableCombos];
  } else {
    const unavailableItems = products.map((product) =>
      parseInt(product.flatProduct.product_id)
    );

    const unavailableCombos = combos.map((combo) => parseInt(combo?.id));

    unavailableProducts = [...unavailableItems, ...unavailableCombos];
  }

  return unavailableProducts;
};

export default identifyCartChanges;
